import {
  Ach_Enrollment_Status,
  FuelAndConvenienceProfileFragment,
  Restriction_Verification_Source,
} from '@occc/graphql';

type ProfileField = {
  name: string;
  attribute: keyof Omit<FuelAndConvenienceProfileFragment, '__typename' | 'createdAt'>;
  defaultValue: string;
  valueMap?: Record<string, string>;
};

const restrictionVerificationSourceMap: Record<Restriction_Verification_Source, string> = {
  [Restriction_Verification_Source.LexisNexis]: 'LexisNexis',
  [Restriction_Verification_Source.TobaccoTransaction]: 'Segmented; no EAIV',
  [Restriction_Verification_Source.AvtTransaction]: 'Segmented; no EAIV',
};

const achEnrollmentStatusToHumanReadableACHStatusMap: Record<Ach_Enrollment_Status, string> = {
  [Ach_Enrollment_Status.Active]: 'Active',
  [Ach_Enrollment_Status.Expired]: 'Expired',
  [Ach_Enrollment_Status.Hold]: 'Hold',
  [Ach_Enrollment_Status.PendingEnrollment]: 'Pending Enrollment',
  [Ach_Enrollment_Status.Rejected]: 'Rejected',
  [Ach_Enrollment_Status.Suspended]: 'Suspended',
  [Ach_Enrollment_Status.WaitingApproval]: 'Waiting Approval',
};

const fields: ProfileField[] = [
  {
    name: 'Acquisition Channel',
    attribute: 'acquisitionChannel',
    defaultValue: 'Unknown',
  },
  {
    name: 'EAIV Status',
    attribute: 'restrictionVerification',
    defaultValue: 'Unknown',
  },
  {
    name: 'EAIV Status Source',
    attribute: 'restrictionVerificationSource',
    defaultValue: 'Unknown',
    valueMap: restrictionVerificationSourceMap,
  },
];

const ACHField: ProfileField = {
  name: 'Enrolled in ACH',
  attribute: 'achEnrollmentStatus',
  defaultValue: 'Unknown',
  valueMap: achEnrollmentStatusToHumanReadableACHStatusMap,
};

export const buildFields = (achEnabled: boolean): ProfileField[] => {
  if (achEnabled) {
    return [...fields, ACHField];
  }

  return fields;
};
